import Nullstack from 'nullstack';
export default function IconCircuitDiodeZener({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-circuit-diode-zener",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M22 12h-6"
  }), "   ", Nullstack.element("path", {
    d: "M2 12h6"
  }), "   ", Nullstack.element("path", {
    d: "M8 7l8 5l-8 5z"
  }), "   ", Nullstack.element("path", {
    d: "M14 7h2v10h2"
  }), " ");
}